import { render, staticRenderFns } from "./PlayerAdmin.vue?vue&type=template&id=478f3780&scoped=true"
import script from "./PlayerAdmin.vue?vue&type=script&lang=js"
export * from "./PlayerAdmin.vue?vue&type=script&lang=js"
import style0 from "./PlayerAdmin.vue?vue&type=style&index=0&id=478f3780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f3780",
  null
  
)

export default component.exports